document.addEventListener('DOMContentLoaded', function () {
    function setupToggle(selector, activeBorder, activeBg, activeIcon, inactiveBorder, inactiveBg, inactiveIcon) {
        document.querySelectorAll(selector).forEach(function (el) {
            el.addEventListener('click', function () {
                var isActive = el.classList.contains(activeBorder);
                var iconContainer = el.querySelector('.checkPlus_icon.checkSol');
                var txt = el.querySelector('.checkPlus_Txt');
                var icon = el.querySelector('.checkPlus_icon span.material-symbols-outlined');

                if (!isActive) {
                    el.classList.remove(inactiveBorder, inactiveBg, 'bg-white');
                    el.classList.add(activeBorder, 'bg-primary-light');
                    if (txt) txt.textContent = 'Servizio aggiunto';
                    if (icon) icon.textContent = activeIcon;
                    if (iconContainer) iconContainer.classList.add('active');
                } else {
                    el.classList.remove(activeBorder, 'bg-primary-light');
                    el.classList.add(inactiveBorder, 'bg-white');
                    if (txt) txt.innerHTML = 'Aggiungi il servizio <span class="material-symbols-outlined md-24">arrow_right</span > ';
                    if (icon) icon.textContent = inactiveIcon;
                    if (iconContainer) iconContainer.classList.remove('active');
                }
            });
        });
    }

    setupToggle(
        '.checkPlus_acquista',
        'border-primary', 'bg-primary', 'check',
        'border-secondary-subtle', 'bg-white', 'add'
    );
    setupToggle(
        '.checkPlus_vendi',
        'border-lime', 'bg-lime', 'check',
        'border-secondary-subtle', 'bg-white', 'add'
    );
});